import { useState, useEffect } from 'react';
import { getAnnonces } from 'src/service/annonceApi';
import { useNotification } from 'src/contexts/NotificationContext';

export const useExpeditionCount = () => {
  const [expeditionCount, setExpeditionCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const { refreshTrigger } = useNotification();

  const fetchExpeditionCount = async () => {
    try {
      const annonces = await getAnnonces('?status=A_EXPEDIER');
      setExpeditionCount(annonces.length || 0);
    } catch (error) {
      console.error('Erreur lors de la récupération du nombre d\'objets à expédier:', error);
      setExpeditionCount(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchExpeditionCount();
    
    // Rafraîchir toutes les 30 secondes
    const interval = setInterval(fetchExpeditionCount, 30000);
    
    return () => clearInterval(interval);
  }, [refreshTrigger]); // Ajouter refreshTrigger comme dépendance

  return { expeditionCount, loading, refetch: fetchExpeditionCount };
}; 